import axios, { AxiosResponse } from 'axios';
import { store } from '../../index';
import * as AppData from '../../store/AppData';
import Helpers from './Helpers';


export default class AxiosRequest {

    static get = async (api: string, headers: any): Promise<AxiosResponse> => {

        if (headers.headers?.Authorization) headers.headers.Authorization = store.getState().appData.tokens;
        let response = await axios.get(api, headers);
        if (response.data.code === 124 || response.data.code == "INVALID_ACCESS_TOKEN") {

            if (headers.headers?.Authorization) {

                let newTokenData = await AxiosRequest.refreshToken();
                if (newTokenData.data.error === "invalid_grant") {
                    Helpers.deleteZoomTokens()
                    return response;
                }

                else {
                    let response = Helpers.setZoomTokens(store.getState().appData.app4legalData["api-base-url"], newTokenData.data);
                    response.then((res) => {
                    });
                    store.dispatch(AppData.actionCreators.fillTokens(newTokenData.data));
                    headers.headers.Authorization = newTokenData.data;
                }

                return await AxiosRequest.get(api, headers);
            }
        } else if (response.data.error === "invalid_grant") {
            Helpers.deleteZoomTokens();
            return response;
        }
        return response;
    };

    static post = async (api: string, dataToPost: any, headers: any): Promise<AxiosResponse> => {
        let response: AxiosResponse;
        if (headers.headers?.Authorization) headers.headers.Authorization = store.getState().appData.tokens;
        response = await axios.post(api, dataToPost, headers);
        console.log("refresh");
        if (response.data.code === 124 || response.data.code == "INVALID_ACCESS_TOKEN") {
            if (headers.headers?.Authorization) {

                let newTokenData = await AxiosRequest.refreshToken();
                if (newTokenData.data.error === "invalid_grant") {
                    Helpers.deleteZoomTokens()
                    return response;
                }
                else {
                    let response = Helpers.setZoomTokens(store.getState().appData.app4legalData["api-base-url"], newTokenData.data);
                    response.then((res) => {
                    });
                    //store.dispatch(AppData.actionCreators.fillRefreshTokenData(newTokenData.data.refresh_token));
                    //store.dispatch(AppData.actionCreators.fillAccessTokenData(newTokenData.data.access_token));
                    store.dispatch(AppData.actionCreators.fillTokens(newTokenData.data));
                    headers.headers.Authorization = newTokenData.data;
                }

                return await AxiosRequest.post(api, dataToPost, headers);
            }
            return await AxiosRequest.post(api, dataToPost, headers);
        } else if (response.data.error === "invalid_grant") {
            Helpers.deleteZoomTokens();
            return response;
        }

        return response;
    };
    static refreshToken = async () => {
        let response: any = await axios.post("api/zoom/token/refresh", {
            /*"refresh_token": store.getState().appData.zoom_refresh_token*/
             "refresh_token": store.getState().appData.tokens
        },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        return response;
    }
    static removeLoginData = () => {
        let response = Helpers.setZoomTokens(store.getState().appData.app4legalData, "");
        response.then((res) => {
        });
        store.dispatch(AppData.actionCreators.fillTokens(""));
    }

};

